import { render } from "preact";
import App from "./App";

import "./css/reset.css";
import "./css/main.css";

render(<App />, document.getElementById("app")!);
